import { Props as SelectProps } from "react-select";

import { Option } from "@/@types/generics/Option";
import { MONTHS } from "@/utils/enums/DateEnum";
import { getMonthsFromQuarter } from "@/utils/quarters";

import { SelectComponent } from "../SelectComponent";

type Props = SelectProps & {
    quarter?: string;
};

export const monthOptions: Option<string>[] = MONTHS.map((MONTH, index) => {
    return {
        value: String(index + 1).padStart(2, "0"),
        label: MONTH,
    };
});

export function getMonthOptionsFromQuarter(quarter: string): Option<string>[] {
    const match = /^Q([1-3])\/\d{4}$/.exec(quarter);

	if (!match) return [];

	const quarterNumber = Number(match[1]);

	const startIndex = (quarterNumber - 1) * 4;
    
    return getMonthsFromQuarter(quarter).map((MONTH, index) => {
        
        return {
            value: String(startIndex + index + 1).padStart(2, "0"),
            label: MONTH,
        };
    })
}

export function MonthsSelect({ quarter, ...rest }: Props) {
    const options = quarter ? getMonthOptionsFromQuarter(quarter) : monthOptions;
    
    return (
        <div className="d-flex flex-column">
            <label htmlFor={rest.id} className="form-label">
                Meses:
            </label>
            <SelectComponent
                id={rest.id}
                placeholder="Selecione..."
                noOptionsMessage={() => "Nenhum quadrimestre encontrado"}
                options={options}
                {...rest}
            />
        </div>
    );
}
